import { useLanguageRedirect } from '../hooks/useLanguageRedirect';

interface LanguageRouterProps {
  children: React.ReactNode;
}

export const LanguageRouter: React.FC<LanguageRouterProps> = ({ children }) => {
  useLanguageRedirect();
  return <>{children}</>;
};